<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_course_schedule')"
                        :is-filter="false"
                >
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_course_schedule')"
                              :is-filter="false"

                >
                </HeaderMobile>
            </template>

            <vue-cal
                :events="events"
                active-view="month"
                :disable-views="['years','year']"
                :time-step="60"
                events-on-month-view
                :selected-date="startDate"
                @view-change="onViewChange"
                class="custom-vuecal"
                :on-event-click="showVueCalModal"
                :cell-height="cellHeight"
            >
                <template #event="{ event }">
                    <div
                        class="vuecal__event-title border"
                        :style="{ backgroundColor: event.color, color: '#fff' }"
                        v-html="event.title"
                    ></div>

                    <em class="vuecal__event-time">
                        <strong>{{ $t('date') }}:</strong><br>
                        <span>{{ toLocaleDate(event.date) }}</span>
                        <br/>
                        <span>
                            <strong>{{ $t('classroom_name') }}:</strong><br>
                            <span>{{ event.classroom_name ?? '-' }}</span>
                        </span>
                        <br>
                        <span>
                            <strong>{{ $t('course_name') }}:</strong><br>
                            <span>{{ event.course_name ?? '-' }}</span>
                        </span>
                    </em>
                    <br/>

                </template>
            </vue-cal>
        </app-layout>

        <CommonModal ref="ShowModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('detail') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <div>
                    <ValidationObserver ref="refundRequestForm">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group :label="$t('classroom_name')">
                                    <div class="label-as-input">{{form.classroom_name}}</div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group :label="$t('course_name')">
                                    <div class="label-as-input">{{form.course_name}}</div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group :label="$t('course_code')">
                                    <div class="label-as-input">{{form.course_code}}</div>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group :label="$t('date')">
                                    <div class="label-as-input">{{form.date}}</div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                </div>
            </template>
        </CommonModal>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
// Components
// Others
import moment from 'moment';

import qs from 'qs'
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import '/src/locales/en/vuecal.js'
import DailyCourseScheduleService from "@/services/DailyCourseScheduleService";

export default {
    components: {
        AppLayout,
        Header,
        VueCal,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t('lesson_timetable')
        }
    },
    data() {
        return {
            events: [],
            cellHeight: 500,
            loading: false,
            startDate: null,
            filter: {
                by_month: null,
            },
            form: {
                start_time: null,
                end_time: null,
                color: null,
                classroom_name: null,
                course_name: null,
                course_code: null,
                date: null,
                style: null,
                start: null,
                end: null,
                title: null
            },
            currentMonth: null,
            currentYear: null
        }
    },
    created() {
        this.startDate = moment().format('YYYY-MM-DD');
    },
    mounted() {
        this.dateFormat()
    },
    methods: {
        dateFormat() {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            this.filter.by_month = `${month},${year}`;
            this.getRows()
        },
        getRandomColor(event) {
            let letters;
            if (event.request_data?.route === 'from_airport_to_island_condos') {
                letters = 'F02121'
            } else {
                letters = '00FF00'
            }
            let color = '#';
            color += letters;
            return color;
        },
        onViewChange({startDate, view}) {
            if (view !== 'week') {
                this.setCurrentMonthAndYear(startDate);
            }
        },
        addTime(date, time) {
            const formattedDate = moment(date, 'MM/DD/YYYY HH:mm')
                .add(time, 'minutes')
                .format('MM/DD/YYYY HH:mm');
            return formattedDate;
        },

        setCurrentMonthAndYear(date) {
            this.currentMonth = date?.getMonth() + 1;
            this.currentYear = date?.getFullYear();
            this.filter.by_month = this.currentMonth + ',' + this.currentYear;
            this.getRows()
        },
        getRows() {
            let user = this.$store.state.auth.user
            if (user.id == null || user.id == '') return

            return DailyCourseScheduleService.getOfStudent(user.id)
                .then((response) => {
                    const data = response.data.data;
                    const schedules = Object.entries(data.daily_course_schedules)
                        .flatMap(([date, events]) =>
                            events
                                .filter((event) => date && event.start_time && event.end_time)
                                .map((event) => {
                                    const startDateTime = moment(`${date} ${event.start_time}`, 'YYYY-MM-DD HH:mm');
                                    const endDateTime = moment(`${date} ${event.end_time}`, 'YYYY-MM-DD HH:mm');

                                    if (!startDateTime.isValid() || !endDateTime.isValid()) {
                                        return null;
                                    }

                                    return {
                                        title: event.code,
                                        date: date,
                                        start: startDateTime.toDate(),
                                        end: endDateTime.toDate(),
                                        start_time: startDateTime.format('HH:mm'),
                                        end_time: endDateTime.format('HH:mm'),
                                        color: this.getRandomColor(event),
                                        classroom_name: event.classroom_name,
                                        course_name: this.getLocaleText(event, "name"),
                                        course_code: event.code,
                                    };
                                })
                                .filter(Boolean)
                        );

                    this.events = schedules;

                }).catch(error => {
                    this.showErrors(error)
                })
        },
        showVueCalModal(event, e) {
            this.form = {
                course_name: event.course_name || null,
                course_code: event.course_code || null,
                classroom_name: event.classroom_name || null,
                start_time: event.start_time || null,
                end_time: event.end_time || null,
                date: event.date || null,
            };

            this.$refs.ShowModal.$refs.commonModal.show()
        },
        formClear() {
            this.$refs.ShowModal.$refs.commonModal.hide()
            this.form = {
                start_time: null,
                end_time: null,
                color: null,
                classroom_name: null,
                course_name: null,
                course_code: null,
                date: null,
                style: null,
                start: null,
                end: null,
                title: null
            }
        },
    }
}
</script>
<style>
.vuecal__cell {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100px;
    height: auto;
    transition: 0.15s ease-in-out background-color;
}

</style>

